export default __webpack_public_path__ + "static/media/our-services-social-care-elderly-care-services-01.59394f1f.jpg";